'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$URL$$anon$141(outer) {
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
}
export { $c_Lpresto_types$URL$$anon$141 as $c_Lpresto_types$URL$$anon$141 };
$p = $c_Lpresto_types$URL$$anon$141.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_s_Conversion();
$p.constructor = $c_Lpresto_types$URL$$anon$141;
/** @constructor */
function $h_Lpresto_types$URL$$anon$141() {
}
export { $h_Lpresto_types$URL$$anon$141 as $h_Lpresto_types$URL$$anon$141 };
$h_Lpresto_types$URL$$anon$141.prototype = $p;
$p.v = (function(x) {
  return x;
});
var $d_Lpresto_types$URL$$anon$141 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$URL$$anon$141, "presto.types$URL$$anon$141", ({
  a2z: 1,
  cz: 1,
  t: 1
}));
export { $d_Lpresto_types$URL$$anon$141 as $d_Lpresto_types$URL$$anon$141 };
//# sourceMappingURL=presto.types$-U-R-L$$anon$141.js.map
